import { getRecurrencesSorted } from '@/server-data'

export function getRecurrences(
  unifiedVehicle: uui.domain.client.UnifiedVehicle,
): uui.domain.rm.Recurrence[] {
  if (!unifiedVehicle.hasRoutingLicense) return []

  return getRecurrencesSorted(Object.keys(unifiedVehicle.vehicle.settings), true, true)
}
